import clsx from 'clsx'
import Quill, { StringMap } from 'quill'
import { forwardRef, useEffect } from 'react'
import ReactQuill from 'react-quill'
import { ReactQuillProps } from 'react-quill/lib'
const Block = Quill.import('blots/block')
class DivBlock extends Block {
  static tagName = 'div'
}
const SizeStyle = Quill.import('attributors/style/size')
SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '24px', '32px']
Quill.register(SizeStyle, true)

Quill.register(DivBlock, true)

export interface IReactQuillEditor extends ReactQuillProps {}
interface ICustomEditor extends IReactQuillEditor {
  error?: any
}

/****Loading*****/
/*********Module********/
const moduleEditors: StringMap = {
  toolbar: [
    // [{header: '1'}, {header: '2'}, {font: []}],
    // [{size: []}],n
    // [{ font: [] }],
    [{ size: ['16px', '12px', '24px', '32px'] }],
    ['bold', 'italic', 'strike', 'underline'],
    ['blockquote', 'code-block'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    [{ direction: 'rtl' }],
    // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ align: [] }],

    ['link'],
    ['clean'],
  ],
  clipboard: {
    // API HTML often uses <div><br></div> for blanks; matchVisual adds extra
    // newlines on paste and duplicates those blocks.
    matchVisual: false,
  },
}
/*********Formats********/
const formatEditors = [
  'header',
  // 'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  // 'image',
  // 'video',
  'color',
  'background',
  'link',
  // 'image',
  // 'video',
]

const ReactQuillEditor = forwardRef((props: ICustomEditor, ref: any) => {
  const {
    modules = moduleEditors,
    formats = formatEditors,
    theme = 'snow',
    style,
  } = props || {}
  useEffect(() => {
    const parentSize = document.querySelector('.ql-size.ql-picker')
    const sizeSelect = parentSize.querySelectorAll('.ql-picker-item')
    const sizeLabel = parentSize.querySelectorAll('.ql-picker-label')
    if (sizeLabel) {
      sizeLabel?.forEach((option: HTMLElement) => {
        switch (option.getAttribute('data-value')) {
          case '12px':
            option.setAttribute('data-value', 'Small')
            break
          case '16px':
            option.setAttribute('data-value', 'Normal')
            break
          case '24px':
            option.setAttribute('data-value', 'Large')
            break
          case '32px':
            option.setAttribute('data-value', 'Huges')
            break
        }
      })
    }
    if (sizeSelect) {
      sizeSelect?.forEach((option: HTMLElement) => {
        switch (option.getAttribute('data-value')) {
          case '12px':
            option.setAttribute('data-value', 'Small')
            option.style.fontSize = '12px'
            break
          case '16px':
            option.setAttribute('data-value', 'Normal')
            option.style.fontSize = '16px'

            break
          case '24px':
            option.setAttribute('data-value', 'Large')
            option.style.fontSize = '24px'

            break
          case '32px':
            option.setAttribute('data-value', 'Huge')
            option.style.fontSize = '32px'
            break
        }
      })
    }
  }, [])
  return (
    <ReactQuill
      className={clsx('customize-quill', props.className)}
      ref={ref}
      modules={modules}
      formats={formats}
      theme={theme}
      preserveWhitespace={false}
      style={style}
      {...props}
    />
  )
})

export default ReactQuillEditor
